import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, X, Save, Store } from "lucide-react";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function MarketplaceCatalog() {
  const [catalog, setCatalog] = useState(null);
  const [newService, setNewService] = useState({});

  useEffect(() => { api.get("/admin/marketplace-catalog").then((r) => setCatalog(r.data)); }, []);

  const addService = (provider) => {
    const val = (newService[provider] || "").trim();
    if (!val) return;
    setCatalog((c) => ({ ...c, [provider]: { ...c[provider], services: [...c[provider].services, val] } }));
    setNewService((n) => ({ ...n, [provider]: "" }));
  };
  const removeService = (provider, i) => {
    setCatalog((c) => ({ ...c, [provider]: { ...c[provider], services: c[provider].services.filter((_, idx) => idx !== i) } }));
  };

  const save = async () => { await api.put("/admin/marketplace-catalog", { data: catalog }); toast.success("Marketplace catalog saved"); };

  if (!catalog) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--accent))]" /></div>;

  return (
    <div>
      <PageHeader title="Marketplace Catalog" subtitle="Master catalog of services offered by SEQ, FSS and Amden across the platform.">
        <Button className="rounded-full" onClick={save} data-testid="save-catalog-btn"><Save className="mr-2 h-4 w-4" /> Save Catalog</Button>
      </PageHeader>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {Object.entries(catalog).map(([provider, info]) => (
          <Card key={provider} className="rounded-2xl border-border p-5">
            <div className="mb-4 flex items-center gap-2">
              <span className="h-3 w-3 rounded-full" style={{ background: info.color }} />
              <div className="font-heading text-base font-semibold">{provider}</div>
              <Store className="ml-auto h-4 w-4 text-muted-foreground" />
            </div>
            <div className="space-y-1.5">
              {info.services.map((s, i) => (
                <div key={i} className="flex items-center justify-between rounded-lg bg-secondary/60 px-3 py-2 text-sm">
                  {s}
                  <button onClick={() => removeService(provider, i)} className="text-muted-foreground hover:text-destructive" data-testid={`remove-${provider}-${i}`}><X className="h-3.5 w-3.5" /></button>
                </div>
              ))}
            </div>
            <div className="mt-3 flex gap-2">
              <Input value={newService[provider] || ""} onChange={(e) => setNewService({ ...newService, [provider]: e.target.value })}
                onKeyDown={(e) => e.key === "Enter" && addService(provider)} placeholder="Add service…" className="h-9" data-testid={`add-input-${provider}`} />
              <Button size="icon" variant="outline" className="h-9 w-9 shrink-0 rounded-lg" onClick={() => addService(provider)} data-testid={`add-btn-${provider}`}><Plus className="h-4 w-4" /></Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
